export enum ProcessoAuditoriaAcessoComponente {
  METADADOS = <any> 'METADADOS',
  DOCUMENTOS = <any> 'DOCUMENTOS',
  PARTES = <any> 'PARTES',
  MOVIMENTOS = <any> 'MOVIMENTOS',
  DOCUMENTO_CONTEUDO = <any> 'DOCUMENTO_CONTEUDO',
  DOCUMENTO_TEXTO = <any> 'DOCUMENTO_TEXTO',
  ASSUNTOS = <any> 'ASSUNTOS',
  CLASSES = <any> 'CLASSES',
  COMPLETO = <any> 'COMPLETO',
  DISTRIBUICOES = <any> 'DISTRIBUICOES',
  DOCUMENTO_METADADOS = <any> 'DOCUMENTO_METADADOS',
  IDENTIFICACAO_PETICAO_INICIAL = <any> 'IDENTIFICACAO_PETICAO_INICIAL',
  RELACIONAMENTOS = <any> 'RELACIONAMENTOS',
  GRAPHQL = <any> 'GRAPHQL',
}
